module.exports = __webpack_public_path__ + "static/media/gy.5d77eb46.svg";